import { GetPaginationRes } from '@hglobal/fin-ui';
import { delay, Observable, of } from 'rxjs';

import { SUPPORT_TELEGRAM_LINK } from '@zeusm/business/core/entities';

import { getRatesMock } from '../../features/rate-conditions/exchange-rates/rates/rates.mock';
import { ApiSettings, ConditionsResponse } from '../entities';

const MOCK_DELAY = 500;

export const cryptoMarketMock: GetPaginationRes<any> = {
  items: [],
  itemsCount: 0,
};

export const settingsMock: ApiSettings = {
  agentAccounts: {
    enabled: false,
    url: '',
  },
  phoneCodes: {
    restricted: [],
  },
};

export const conditionsMock: ConditionsResponse = {
  sections: [
    {
      name: 'Mock conditions',
      items: [{ key: 'Business account maintenance', value: '0 EUR' }],
    },
  ],
};

export const totalBalanceMock = '0';

export const hasAgentAccountsMock = false;

export const supportLinkMock = {
  url: SUPPORT_TELEGRAM_LINK,
};

export const telegramLinkMock = SUPPORT_TELEGRAM_LINK;

export function getRatesResMock() {
  return { items: getRatesMock() };
}

export function mockResponse<T>(value: T): Observable<T> {
  return of(value).pipe(delay(MOCK_DELAY));
}
